/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { ButtonBase } from "../ButtonBase";
import { isUndefined } from "@adapptio/lib-shared";

export interface ICardProps extends React.ComponentPropsWithRef<"div"> {
	className?: string;
	button?: boolean;
	variant?: "default" | "primary";
	selected?: boolean;
}

export const Card: React.FC<ICardProps> = ({ children, className, button, variant, selected, ...props }) => {
	const baseClass = BEM("edt-card", null, {
		button,
		variant,
		selected,
		selectable: !isUndefined(selected)
	});

	if (className) {
		baseClass.add(className);
	}

	const commonProps = {
		className: baseClass.toClassName(),
		...props
	};

	if (button) {
		return (
			<ButtonBase Component="div" {...commonProps}>
				{children}
			</ButtonBase>
		);
	}

	return <div {...commonProps}>{children}</div>;
};

Card.defaultProps = {
	variant: "default"
};
